<template>
	<teleport to="body">
		<ScheduleExample
			v-bind:which="which"
			v-bind:content="content"
			v-bind:tabType="'img'"
			v-on:show-overlay="showOverlay"
		></ScheduleExample>
	</teleport>
</template>
<script>
import ScheduleExample from '@/components/ScheduleExample'
export default {
	components: {
		ScheduleExample
	},
	data() {
		return {
			which: this.$route.params.which,
			content: {
				'ven-g': {
					ScheduleExample: {
						dirpath: 'calendars',
						title: 'VEN+G INITIATION SCHEDULE EXAMPLE',
						title_sup: 1,
						tabs: {
							tab0: {
								name: "Low Tumor Burden",
								panels: [
									{
										img_main: 892,
										img_main_alt: 892
									},
									{
										img_main: 892
									}
								]
							},
							tab1: {
								name: "Medium Tumor Burden",
								panels: [
									{
										img_main: 892,
										img_main_alt: 892
									},
									{
										img_main: 892
									}
								]
							},
							tab2: {
								name: "High Tumor Burden",
								panels: [
									{
										img_main: 892,
										img_main_alt: 892
									},
									{
										img_main: 892
									}
								]
							}
						}
					}
				},
				'ven-r': {
					ScheduleExample: {
						dirpath: 'calendars',
						title: 'VEN+R INITIATION SCHEDULE EXAMPLE',
						title_sup: 1,
						tabs: {
							tab0: {
								name: "Low Tumor Burden",
								panels: [
									{
										img_main: 892,
									},
									{
										img_main: 892
									}
								]
							},
							tab1: {
								name: "Medium Tumor Burden",
								panels: [
									{
										img_main: 892,
									},
									{
										img_main: 892
									}
								]
							},
							tab2: {
								name: "High Tumor Burden",
								panels: [
									{
										img_main: 892,
									},
									{
										img_main: 892
									}
								]
							}
						}
					}
				}
			}
		}
	},
	methods: {
		showOverlay(){
			this.$router.push('/aml-cll/intro/calendars')
		}
	},
}
</script>